// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2LJ40","approved":"Status_approved__1d0au","rejected":"Status_rejected__3IgLR","expired":"Status_expired__3k4zo","label":"Status_label__1gliy"};